import ReactGA from 'react-ga'

ReactGA.initialize(process.env.GA_TRACKING_ID)

export const trackPage = page => {
  let screenName = ''
  switch (true) {
    case /^\/announcement$/.test(page):
      screenName = 'INFO_DETAIL'
      break
    case /^\/lines\/main\/trains$/.test(page):
      screenName = 'LOCATE_TRAIN_MAIN_LINE'
      break
    case /^\/lines\/izumino\/trains$/.test(page):
      screenName = 'LOCATE_TRAIN_IZUMINO_LINE'
      break
    case /^\/lines\/(?:main|izumino)\/trains\/([0-9]+)$/.test(page):
      screenName = `TRAIN_DETAIL_${RegExp.$1}`
      break
    case /^\/lines\/(?:main|izumino)\/route_map$/.test(page):
      screenName = 'LINE_GUIDE'
      break
    case /^\/stations\/([0-9]+)$/.test(page):
      screenName = `STATION_INFO_${RegExp.$1}`
      break
    case /^\/stations\/(?:[0-9]+)\/station_view$/.test(page):
      screenName = 'STATION_VIEW'
      break
    case /^\/delay_certificates$/.test(page):
      screenName = 'DELAY_CERTIFICATE'
      break
    case /^\/delay_certificates\/([0-9]+)$/.test(page):
      screenName = `DELAY_CERTIFICATE_${RegExp.$1}`
      break
    case /^\/entertainment$/.test(page):
      screenName = 'ENTERTAINMENT'
      break
    case /^\/terms$/.test(page):
      screenName = 'TERMS_OF_USE'
      break
    case /^\/contacts$/.test(page):
      screenName = 'INQUIRIES'
      break
    default:
      break
  }
  if (screenName) {
    ReactGA.ga('send', 'screenview', {
      appName: 'sotetsu-app',
      screenName: screenName
    })
    ReactGA.ga('send', 'pageview', page)
  }
}

export const sendGATapEvent = (category, label) => {
  ReactGA.event({
    category: category,
    action: 'TAP',
    label: label
  })
}
